module.exports = __webpack_public_path__ + "assets/img/thumb-Nexon-1-Landing-Page.104eea77.jpg";